export enum NumberOnlyEnum {
    Integer = "integer",
    Decimal = "decimal"
}